export default {
      id: "countryFlag-Tajikistan-usage",
      viewBox: "0 0 400 266.25",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#countryFlag-Tajikistan",
      toString: function () {
        return this.url;
      }
    }